// extracted by mini-css-extract-plugin
export var active = "Accordion-module--active--a9545";
export var collapseButton = "Accordion-module--collapseButton--eaad1";
export var collapseItems = "Accordion-module--collapseItems--729b0";
export var fadeInAnimation = "Accordion-module--fadeInAnimation--3a096";
export var subtitle = "Accordion-module--subtitle--6aaf2";
export var wrapper = "Accordion-module--wrapper--303ac";